"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionTracker = void 0;
var cross_fetch_1 = __importDefault(require("cross-fetch"));
var ActionTracker = /** @class */ (function () {
    function ActionTracker(params) {
        this.applicationId = params.applicationId;
        this.endpoint = params.endpoint;
        this.authorization = params.authorization;
    }
    ActionTracker.prototype.buildHeaders = function () {
        var headers = {
            'Content-Type': 'application/json',
            'x-vt-applicationid': this.applicationId,
        };
        if (this.authorization) {
            headers['Authorization'] = this.authorization;
        }
        return headers;
    };
    ActionTracker.prototype.validate = function (action) {
        if (!this.endpoint) {
            throw new TypeError('[ActionTracker] - endpoint was not set');
        }
        if (!this.applicationId) {
            throw new TypeError('[ActionTracker] - applicationId was not set');
        }
        if (Object.keys(action).length === 0) {
            throw new TypeError('[ActionTracker] - No action tracker data was given');
        }
    };
    ActionTracker.prototype.track = function () {
        return __awaiter(this, arguments, void 0, function (action, retryEnabled) {
            var headers, sendRequest, error_1, shouldRetry;
            var _this = this;
            if (action === void 0) { action = {}; }
            if (retryEnabled === void 0) { retryEnabled = false; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.validate(action);
                        headers = this.buildHeaders();
                        sendRequest = function () {
                            var args_1 = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args_1[_i] = arguments[_i];
                            }
                            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (keepAliveOption) {
                                if (keepAliveOption === void 0) { keepAliveOption = true; }
                                return __generator(this, function (_a) {
                                    return [2 /*return*/, (0, cross_fetch_1.default)(this.endpoint, {
                                            method: 'POST',
                                            headers: headers,
                                            credentials: 'include',
                                            mode: 'cors',
                                            keepalive: keepAliveOption,
                                            body: JSON.stringify(action),
                                        })];
                                });
                            });
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 6]);
                        return [4 /*yield*/, sendRequest()];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        error_1 = _a.sent();
                        shouldRetry = error_1 instanceof TypeError && error_1.message === 'Failed to fetch' && retryEnabled;
                        if (!shouldRetry) return [3 /*break*/, 5];
                        return [4 /*yield*/, sendRequest(false)];
                    case 4: return [2 /*return*/, _a.sent()];
                    case 5: throw error_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    return ActionTracker;
}());
exports.ActionTracker = ActionTracker;
